import {
  GetpssByUuidQuery,
  GetpssByUuidQueryVariables,
  Get_AddonsQuery,
  Get_AddonsQueryVariables,
  Get_Membership_By_Voucher_CodeQuery,
  Get_Membership_By_Voucher_CodeQueryVariables,
  Get_PssListByUuiDsQuery,
  Get_PssListByUuiDsQueryVariables,
} from "@/types/gql/generated/graphql";
import { apolloClient } from "@/utils/graphql-client";
import {
  GET_ADDONS,
  GET_MEMBERSHIP_BY_VOUCHER_CODE,
  GET_PSSByUUID,
  GET_PSSListByUUIDs,
} from "./queries/product-slot-state.graphql";
import { BookingStatus } from "@/types/db/product-slot-state";
import { PCTypes } from "@/types/db/product-category";

/**
 * Returns addons
 * @param bookingIds: string[]
 */
export async function getAddons(bookingIds: string[]) {
  const res = await apolloClient.query<
    Get_AddonsQuery,
    Get_AddonsQueryVariables
  >({
    query: GET_ADDONS,
    variables: { bookingIds: bookingIds },
  });

  const result = res.data.ProductSlotStateList;
  return result || [];
}

/**
 * get membership pss using voucher code
 * @param voucherCode
 * @returns token
 */
export async function getMembershipTokenByVoucherCode(
  voucherCode: string,
  groupId: number
) {
  const res = await apolloClient.query<
    Get_Membership_By_Voucher_CodeQuery,
    Get_Membership_By_Voucher_CodeQueryVariables
  >({
    query: GET_MEMBERSHIP_BY_VOUCHER_CODE,
    variables: {
      condition: `(code_unique,eq,${voucherCode})~and(group_id,in,${groupId})`,
    },
  });

  const pssList = res.data.PromoCodeList?.[0]?.ProductSlotStateList || [];
  // get only the pss of type membership with voucher (16)
  const membershipPss =
    pssList.find(
      (pss) =>
        pss?.bookingStatus === BookingStatus.Confirmed &&
        pss?.type === PCTypes.MembershipVoucher
    ) || null;
  return membershipPss?.token || null;
}

/**
 * get pss (Membership and Giftcard) voucher code using pss uuids
 * @param uuids: string[]
 */
export async function getPssListByUuids(uuids: string[]) {
  const res = await apolloClient.query<
    Get_PssListByUuiDsQuery,
    Get_PssListByUuiDsQueryVariables
  >({
    query: GET_PSSListByUUIDs,
    variables: { uuids },
  });
  return res.data.pssList || [];
}

/**
 * Get a pss with its voucher code using the pss token.
 *
 * Filters on the voucher types: with oneTokenVoucherTickets the tickets bought
 * with a voucher carry the voucher's token too, so the token alone matches
 * several pss.
 *
 * @param token pss token read from the QR code
 * @param groupId group the POS is selling for
 */
export async function getPssVoucherByToken(token: string, groupId: number) {
  const voucherTypes = [PCTypes.MembershipVoucher, PCTypes.GiftCard].join(",");

  const res = await apolloClient.query<
    GetpssByUuidQuery,
    GetpssByUuidQueryVariables
  >({
    query: GET_PSSByUUID,
    variables: {
      uuid: `(token,eq,${token})~and(type,in,${voucherTypes})`,
    },
  });

  const uuid = res.data.pssList?.[0]?.uuid;

  if (!uuid) {
    return [];
  }

  return getPssListByUuids([uuid]);
}
